module.exports = __webpack_public_path__ + "media/images/logo-d8554571625070b032ec18e81e4cdc16.png";